var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-cascader",
    _vm._b(
      {
        attrs: {
          "popper-class": "t-cascader-popper",
          options: _vm.getOptions(),
        },
        model: {
          value: _vm.changeValue,
          callback: function ($$v) {
            _vm.changeValue = $$v
          },
          expression: "changeValue",
        },
      },
      "el-cascader",
      Object.assign({}, _vm.item),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }